import HomeIcon from '../../assets/logo/Home.svg'

const HomeCustomIcon = () => (
  <img src={HomeIcon} alt='logo' />
);

export default HomeCustomIcon;